import React from "react";
import { Select as AntdSelect } from "antd";

interface DropdownProps {
  options: Array<{
    label: string;
    value: string | number;
  }>;
  value?: string | number;
  onChange?: (value: string | number) => void;
}

const Dropdown: React.FC<DropdownProps> = ({ options, value, onChange }) => {
  return (
    <AntdSelect
      value={value}
      onChange={onChange}
      options={options}
      placeholder="Chọn"
      style={{ width: "100%" }}
    />
  );
};

export default Dropdown;
